import {action, computed, makeObservable, observable} from 'mobx';
import ApiResponseHandler from '@eryxcoop/appyx-comm/src/errors/ApiResponseHandler';
import handleSuccessToast from '../../../components/toast/SuccessToast';
import handleErrorToast from '../../../components/toast/ErrorToast';
import {ALLOWANCES_PATH} from '../../../routes';
import Allowance from '../Allowance';

export default class CreateAllowanceFeature {
    constructor(application, navigator) {
        this._application = application;
        this._navigator = navigator;
        this._loaded = false;
        this._newAllowance = null;
        this._customerOptions = [];
        this._articleOptions = [];
        this._franchiseBrandOptions = [];
        this._conceptOptions = [
            {label: 'Bonificación comercial', value: 'Bonificación comercial'},
            {label: 'Acuerdo comercial', value: 'Acuerdo comercial'},
        ];

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
            _newAllowance: observable,
            newAllowance: computed,
            _storeOptions: action,
            _initializeNewAllowance: action,
            _finishLoading: action,
        });
    }

    async load() {
        await this.loadOptions();
        this._initializeNewAllowance();
        this._finishLoading();
    }

    async loadOptions() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._storeOptions({
                    customerOptions: response.customers().map(this._customerOption),
                    articleOptions: response.articles().map(this._articleOption),
                    franchiseBrandOptions: response.franchiseBrands().map(this._franchiseBrandOption),
                });
            },
            handlesError: () => {
                handleErrorToast('No se pudieron obtener las opciones para crear la bonificación.');
            },
        });
        return this._application.apiClient().allowanceFormOptions(responseHandler);
    }

    _customerOption(businessName) {
        return {label: businessName, value: businessName};
    }

    _articleOption(article) {
        return {label: `${article.code} - ${article.name}`, value: article.code};
    }

    _franchiseBrandOption(franchiseBrandName) {
        return {label: franchiseBrandName, value: franchiseBrandName};
    }

    get loaded() { return this._loaded; }
    get newAllowance() { return this._newAllowance; }

    submitAllowance() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: () => {
                handleSuccessToast('La bonificación fue creada con éxito.');
                this._navigator(ALLOWANCES_PATH);
            },
            handlesError: () => {
                handleErrorToast('No se pudo crear la bonificación.');
            },
        });
        return this._application.apiClient().createAllowance(this._newAllowance.payload(), responseHandler);
    }

    _storeOptions({customerOptions, articleOptions, franchiseBrandOptions}) {
        this._customerOptions = customerOptions;
        this._articleOptions = articleOptions;
        this._franchiseBrandOptions = franchiseBrandOptions;
    }

    _initializeNewAllowance() {
        this._newAllowance = Allowance.forEdit({
            customerOptions: this._customerOptions,
            articleOptions: this._articleOptions,
            conceptOptions: this._conceptOptions,
            franchiseBrandOptions: this._franchiseBrandOptions,
        });
    }

    _finishLoading() {
        this._loaded = true;
    }
}
